import { WorkspaceTextInput } from "@nova/component-inline-text-input"
import { useEffectUnsafe } from "@nova/use-effect-unsafe"
import { useState } from "react"

export const SidePanelPluginActionsRenamer = ({
    defaultName,
    onRename,
}: {
    defaultName: string
    onRename: (name: string) => void
}) => {
    const [localLayerName, setLocalLayerName] = useState(defaultName)

    useEffectUnsafe(() => {
        onRename(defaultName)
    }, [])

    return (
        <div className="mt-4 mb-4 flex flex-col">
            <small className="text-gray-100">Layer Name</small>
            <div className="mt-2" />
            <WorkspaceTextInput
                name={"layer-name"}
                value={localLayerName}
                handleChange={(name) => {
                    setLocalLayerName(name)
                    onRename(name)
                }}
                inputClassName="!text-gray-0"
            />
        </div>
    )
}
